export default __webpack_public_path__ + "static/index-header-img-ru-32e389e89a5a20ca684580e4ebcc5592.webp";